<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="batchId" >
        <span slot="label" ><a-tooltip>{{$t('批次编号')}}<template slot="title">{{$t('批次编号')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.batchId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'批次编号'" />
      </a-form-model-item>
      <a-form-model-item prop="batchName" >
        <span slot="label" ><a-tooltip>{{$t('批次名称')}}<template slot="title">{{$t('批次名称')}}</template></a-tooltip> </span>
        <a-input v-model="form.batchName" :maxLength="255" :placeholder="$t('请输入')+'批次名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="batchCode" >
        <span slot="label" ><a-tooltip>{{$t('学校口令')}}<template slot="title">{{$t('学校口令')}}</template></a-tooltip> </span>
        <a-input v-model="form.batchCode" :maxLength="64" :placeholder="$t('请输入')+'学校口令'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="batchType" >
        <span slot="label" ><a-tooltip>{{$t('批次标签')}}<template slot="title">{{$t('批次标签')}}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="logisticsType" >
        <span slot="label" ><a-tooltip>{{$t('物流类型')}}<template slot="title">{{$t('物流类型')}}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="mobile" >
        <span slot="label" ><a-tooltip>{{$t('客服电话')}}<template slot="title">{{$t('客服电话')}}</template></a-tooltip> </span>
        <a-input v-model="form.mobile" :maxLength="255" :placeholder="$t('请输入')+'客服电话'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="notice" >
        <span slot="label" ><a-tooltip>{{$t('通知')}}<template slot="title">{{$t('通知')}}</template></a-tooltip> </span>
        <a-input v-model="form.notice" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item prop="isShowNotification" >
        <span slot="label" ><a-tooltip>{{$t('是否显示公告')}}<template slot="title">{{$t('是否显示公告')}}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="notification" >
        <span slot="label" ><a-tooltip>{{$t('公告内容')}}<template slot="title">{{$t('公告内容')}}</template></a-tooltip> </span>
        <a-input v-model="form.notification" :maxLength="255" :placeholder="$t('请输入')+'公告内容'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="startTime" >
        <span slot="label" ><a-tooltip>{{$t('开始时间')}}<template slot="title">{{$t('开始时间')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.startTime" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="endTime" >
        <span slot="label" ><a-tooltip>{{$t('结束时间')}}<template slot="title">{{$t('结束时间')}}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.endTime" :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="schoolId" >
        <span slot="label" ><a-tooltip>{{$t('学校id')}}<template slot="title">{{$t('学校id')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.schoolId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'学校id'" />
      </a-form-model-item>
      <a-form-model-item prop="deptId" >
        <span slot="label" ><a-tooltip>{{$t('部门id')}}<template slot="title">{{$t('部门id')}}</template></a-tooltip> </span>
        <a-input-number v-model="form.deptId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'部门id'" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSchoolBatchChangeLog, addSchoolBatchChangeLog, updateSchoolBatchChangeLog } from '@/api/school/schoolBatchChangeLog'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import moment from 'moment';


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        batchId: null,
        batchName: null,
        batchCode: null,
        batchType: null,
        logisticsType: null,
        mobile: null,
        notice: null,
        isShowNotification: null,
        notification: null,
        startTime: null,
        endTime: null,
        schoolId: null,
        deptId: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          batchId: [{ required: true, message: this.$t('批次编号')+this.$t('不能为空'), trigger: 'blur' }] ,
          batchName: [{ required: true, message: this.$t('批次名称')+this.$t('不能为空'), trigger: 'blur' }] ,
          batchType: [{ required: true, message: this.$t('批次标签')+this.$t('不能为空'), trigger: 'change' }] ,
          logisticsType: [{ required: true, message: this.$t('物流类型')+this.$t('不能为空'), trigger: 'change' }] ,
          mobile: [{ required: true, message: this.$t('客服电话')+this.$t('不能为空'), trigger: 'blur' }] ,
          startTime: [{ required: true, message: this.$t('开始时间')+this.$t('不能为空'), trigger: 'blur' }] ,
          endTime: [{ required: true, message: this.$t('结束时间')+this.$t('不能为空'), trigger: 'blur' }] ,
          schoolId: [{ required: true, message: this.$t('学校id')+this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        batchId: null,
        batchName: null,
        batchCode: null,
        batchType: null,
        logisticsType: null,
        mobile: null,
        notice: null,
        isShowNotification: null,
        notification: null,
        startTime: null,
        endTime: null,
        schoolId: null,
        deptId: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSchoolBatchChangeLog({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateSchoolBatchChangeLog(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addSchoolBatchChangeLog(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
